import React, {Component, Fragment} from "react";
import axios from "axios";
import Clock from "./components/Clock"

const dateFormat = require("dateformat");


const NoRC = (props) => {


    return (
        <div className="row">
            <div className="col-12">
                <div className="alert alert-warning">
                    En este momento el registro civil presenta intermitencia en sus servidores,
                    les pedimos reintentar votar en caso de presentar problemas al validar
                    su cédula de identidad. Si el probema persiste favor contactar la mesa de ayuda
                </div>
            </div>
        </div>

    )
}

class Document extends Component {

    render() {
        const numDoc = this.props.election.configuration.documents.length;
        const numCols = 12 / numDoc;
        const classCols = "col-12 col-sm-" + numCols;
        return (
            <Fragment>
                <hr/>
                <div align="center" class="row justify-content-center mb-3">
                    {this.props.election.configuration.documents.map(f => (
                        <div class={classCols}>
                            <h4>
                                <a href={f.url} target="_blank" rel="noopener noreferrer">{f.name}</a>
                            </h4>
                        </div>
                    ))}
                    <br/>
                </div>
            </Fragment>
        )
    }
}


class ButtonElection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clock: '',
            state: 'none',
            rc: []
        };
    }

    componentDidMount() {

        const end_date = new Date(this.props.election.configuration.end_date).getTime();
        const start_date = new Date(this.props.election.configuration.start_date).getTime();
        const self = this;

        // verifica cada 30 segundos situación en el RC
        setInterval(function () {
            self.loadRC();
        }, 30000);

        setInterval(function () {
            const now = new Date().getTime();
            let distance = start_date - now;
            let state = 'ready';

            if (now >= start_date && now < end_date) {

                distance = end_date - now;
                state = 'open';
            } else if (now >= end_date) {
                state = 'finished';
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            self.setState({
                state: state,
                clock: days + (days !== 1 ? ' días ' : ' día ') + (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds)
            });
        }, 1000);
    }

    loadRC = name => {
        this.setState({loading: true}, () => {
            axios({
                method: "get",
                //url: "/data/demo.evoting.cl.json"
                url: process.env.REACT_APP_BASE_URL + "/rc.json"
            })
                .then(response => {

                    this.setState({loading: false, rc: response.data});
                })
                .catch(error => {
                    this.setState({loading: false});
                })
        });
    };

    render() {

        let button = null;

        switch (this.state.state) {
            case 'open':
                button = <Fragment>
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11  text-center  my-m4 ">
                            <a className="boton open"
                               href={this.props.election.configuration.encrypter_url.replace(/%s/g, this.props.election._id)}><span
                                className="iconvote"></span>Votar</a>

                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11  text-center  my-m4">
                            <div className="finaliza">
                                <p>Finaliza
                                    el {dateFormat(new Date(this.props.election.configuration.end_date), "dd '/' mm '/' yyyy 'a las' HH'.'MM 'hrs.'")}</p>
                                {/* <p>{this.state.clock}</p> */}
                                <Clock date={this.props.election.configuration.end_date}/>
                            </div>
                        </div>
                    </div>
                </Fragment>;
                break;
            case 'finished':
                button =

                    <div className="row justify-content-center">

                        <div className="col-12 col-sm-11  text-center  my-m4 mb-0">
                            <p className="h3 font-weight-bold">Finalizado
                                el {dateFormat(new Date(this.props.election.configuration.end_date), "dd '/' mm '/' yyyy 'a las' HH'.'MM 'hrs.'")}</p>
                        </div>
                        <div className="col-12 col-sm-11  text-center  my-m4 ">
                            <a href="/%PUBLIC_URL%/resultados/resultadosIngenieros2020-A.pdf">Ver Resultados Preliminares Candidatos a Consejeros Nacionales de Libre Elección</a>

                        </div>
                    </div>;
                break;
            case 'ready':
                button = <Fragment>
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11  text-center my-m4 ">
                            <botton className="boton ready" href="/nowhere"><span
                                className="iconvote"></span>Votar<span>(Aún no comienza)</span></botton>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-11  text-center">
                            <div className="finaliza">
                                <p>Comienza
                                    el {dateFormat(new Date(this.props.election.configuration.start_date), "dd '/' mm '/' yyyy 'a las' HH'.'MM 'hrs.'")}</p>
                                {/* <p>{this.state.clock}</p> */}
                                <Clock date={this.props.election.configuration.start_date}/>
                            </div>
                        </div>
                    </div>
                </Fragment>;
                break;
            default:
                button = <div className="row justify-content-center">
                    <div className="col-12 col-sm-11  text-center  my-m4">
                    </div>
                </div>;
                break;
        }

        const [field, pass] = this.props.election.configuration.identification_field.split('+', 2);
        const serial = (pass === 'serial' || pass === 'serial_mobile');
        //console.log(this.state.rc)
        const now = new Date();

        const rc_intermittence = this.state.rc ? this.state.rc.reduce((acc, element) => {
            return (acc || (new Date(element.start) < now && new Date(element.end) > now));
        }, false) : false;


        // Si estamos en un rango con intermitencia y está abierta y usa serial
        return (<Fragment>
            <div className="row justify-content-center">

                <div className="col-12 col-sm-11  text-center  my-m4 mb-0">
                    <p className="h3 font-weight-bold">Finalizado
                        el {dateFormat(new Date(this.props.election.configuration.end_date), "dd '/' mm '/' yyyy 'a las' HH'.'MM 'hrs.'")}</p>
                </div>
                <div className="col-12 col-sm-11  text-center  my-m4 ">
                    <a href="resultadosIngenieros2020-A.pdf?v1">Ver Resultados Preliminares Candidatos a Consejeros Nacionales de Libre Elección</a>
                </div>
                <div className="col-12 col-sm-11  text-center  my-m4 ">
                <a href="resultadosIngenieros2020-B.pdf?v1">Ver Resultados Preliminares Candidatos a Consejeros Representantes de Especialidad</a>
                </div>
                <div className="col-12 col-sm-11  text-center  my-m4 ">
                <a href="resultadosIngenieros2020-C.pdf?v1">Ver Resultados Preliminares Candidatos a Consejeros Zonales</a>
                </div>
                <div className="col-12 col-sm-11  text-center  my-m4 ">
                <a href="resultadosIngenieros2020-D.pdf?v1">Ver Resultados Preliminares Candidatos a Consejeros del Consejo de Especialidad</a>

                </div>
            </div>;            {this.props.election.configuration.document ? <Document election={this.props.election}/> : false}
            <div className="row justify-content-center">


                <div className="col-12 p-4">
                    <p className="font-weight-bold mt-4 mb-4 text-center ">Las características y detalles de esta
                        elección, incluyendo fechas, plazos, papeleta, método de autentificación y otros aspectos
                        concernientes al proceso, han sido aprobados íntegra y explícitamente por el Tribunal
                        Electoral</p>
                </div>
            </div>
        </Fragment>);
    }
}

export default ButtonElection;